// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HepK2DfWTKI76Bjq_6U2{padding:0 8px 8px}.URBwvVJQdNopa04Xifd7{background:var(--background-primary-inverted-primary);border-radius:6px;width:100%;padding:16px;box-shadow:0 4px 12px -2px rgba(18,19,23,.03)}._tAVvh94g9AoHchmc5vU{color:var(--content-primary-primary);padding-bottom:12px}.kXV7WgHk8gaSsGTlbxgU{padding:4px 0 16px}.kFRHlaydVXA7c9OfM5jb{background-color:var(--black-20);border-radius:4px;height:4px}.kFRHlaydVXA7c9OfM5jb>div{border-radius:4px}.kFRHlaydVXA7c9OfM5jb.g_Uw48yNM3A6yY9wumsX>div{background-color:var(--light-blue-60)}.kFRHlaydVXA7c9OfM5jb.ZGkkIeodxY8TRtfoynLx>div{background-color:var(--yellow-60)}.kFRHlaydVXA7c9OfM5jb.Vx8jXG3lgYIs51o6hzNs>div{background-color:var(--red-60)}.FOt7D4OkA0QpRjT5Guvz{gap:8px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `HepK2DfWTKI76Bjq_6U2`,
	"content": `URBwvVJQdNopa04Xifd7`,
	"title": `_tAVvh94g9AoHchmc5vU`,
	"progressWrap": `kXV7WgHk8gaSsGTlbxgU`,
	"progress": `kFRHlaydVXA7c9OfM5jb`,
	"default": `g_Uw48yNM3A6yY9wumsX`,
	"yellow": `ZGkkIeodxY8TRtfoynLx`,
	"red": `Vx8jXG3lgYIs51o6hzNs`,
	"button": `FOt7D4OkA0QpRjT5Guvz`
};
export default ___CSS_LOADER_EXPORT___;
